import { useMerchant } from '@olo-web/domain';
import { useFeatureFlags } from '@olo-web/domain/featureFlags/queries/useFeatureFlags';
import { isFeatureEnabledForMerchant } from '@olo-web/utils/common';

export const useItemUpsellFeatureABTesting = (): {
  showCarosel: boolean;
  showSplashScreen: boolean;
  isABTestingEnabled: boolean;
} => {
  const { data: flags } = useFeatureFlags();
  const { data: merchant } = useMerchant();
  const ABTestAllowDenyList = flags?.ItemUpsellFeatureAllowDeny;
  const isABTestingEnabled = isFeatureEnabledForMerchant({
    featureEnabled: ABTestAllowDenyList?.on,
    allowList: ABTestAllowDenyList?.allow,
    denyList: ABTestAllowDenyList?.deny,
    merchantId: merchant?.merchantId,
  });
  const showCarosel = flags?.ItemUpsellFeatureABTest === 1 || !isABTestingEnabled;
  const showSplashScreen = flags?.ItemUpsellFeatureABTest === 2 && isABTestingEnabled;

  return {
    showCarosel,
    showSplashScreen,
    isABTestingEnabled,
  };
};
